// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2HnKw","left":"StickyBox_left__14I-e","right":"StickyBox_right__AqVd1"};